import { useEffect } from "react";

/**
 * Handles clicking outside of the ref.
 * @param {reactRef} ref - react ref object
 * @param {func} callback - called when there is a click outside the ref
 */
const useOutsideClick = (ref, callback) => {
	const handleClick = (e) => {
		if (ref.current && !ref.current.contains(e.target)) {
			callback();
		}
	};

	useEffect(() => {
		document.addEventListener("click", handleClick);

		return () => {
			document.removeEventListener("click", handleClick);
		};
	});
};

export default useOutsideClick;
